import script from "./ManualSettlement.vue?vue&type=script&lang=ts&setup=true"
export * from "./ManualSettlement.vue?vue&type=script&lang=ts&setup=true"

import "./ManualSettlement.vue?vue&type=style&index=0&id=3394c604&lang=scss"

const __exports__ = script;

export default __exports__